import apiService from '@/member/services/apiService'

const getDefaultState = () => {
  return {}
}

const state = getDefaultState()

const mutations = {}

const actions = {
  async getSimulationItems({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.list'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },

  async storeSimulationItem({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.store'), payload)
    if (apiResult && apiResult.success) {
      return apiResult.success
    }
  },

  async editSimulationItems({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.edit'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },

  async updateSimulationItems({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.update'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },

  async duplicateSimulationItems({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.duplicate'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },

  async deleteSimulationItems({ commit }, payload) {
    const apiResult = await apiService.get(route('member.fcs.simulation-item.delete'), payload)
    if (apiResult && apiResult.data) {
      return apiResult.data
    }
  },
}

export default {
  state,
  mutations,
  actions,
}
